import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Dialog, DialogContent, DialogFooter, Button} from '@taopix/taopix-design-system';
import ChangeProductPanel from './ChangeProductPanel';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import {
  AlternativeProductData,
  useChangeProductContext,
} from '../Context/ChangeProduct/ChangeProductContext';
import {Localisation, Lang} from '@taopix/taopix-core';
import {useUserFlowState} from '../Context/UserFlow/UserFlowContext';

export type ChangeProductDialogProps = {
  open: boolean;
  onChangeProduct: (ref: number) => void;
};

const ChangeProductDialog = ({open, onChangeProduct, ...props}: ChangeProductDialogProps) => {
  const ui = useUiState();
  const changeProduct = useChangeProductContext();
  const userFlow = useUserFlowState();
  const {t} = useTranslation();

  const [selectedProduct, setSelectedProduct] = useState<AlternativeProductData>(
    {} as AlternativeProductData
  );

  const alternativeProductData = changeProduct?.state?.alternativeProducts;

  useEffect(() => {
    if (alternativeProductData.length === 0) return;
    //prettier-ignore
    setSelectedProduct({
      ...alternativeProductData?.[0],
      moreInformationURL: Localisation.getLocaleString(Lang.getCode(), alternativeProductData?.[0].moreInformationURL),
      name: Localisation.getLocaleString(Lang.getCode(), alternativeProductData?.[0].name),
      description: Localisation.getLocaleString(Lang.getCode(),alternativeProductData?.[0].description),
    });
  }, [alternativeProductData]);

  return (
    <Dialog
      open={open}
      focusFirstElement
      trapFocus={true}
      width={900}
      height={600}
      id={'change-product'}
      theme={'tpx-theme-dialogs'}
      themeTip="Dialogs"
      title={t('*:str_ButtonChangeProduct')}
      onClose={() => userFlow.setNextStep()}
    >
      <DialogContent>
        <ChangeProductPanel
          onSetSelectedProduct={(selectedProduct: AlternativeProductData) => {
            //prettier-ignore
            setSelectedProduct({
              ...selectedProduct,
              moreInformationURL: Localisation.getLocaleString(Lang.getCode(), selectedProduct?.moreInformationURL),
              name: Localisation.getLocaleString(Lang.getCode(), selectedProduct?.name),
              description: Localisation.getLocaleString(Lang.getCode(), selectedProduct?.description)
            });
          }}
          alternativeProductData={alternativeProductData}
          onChangeProduct={onChangeProduct}
          selectedProduct={selectedProduct}
        ></ChangeProductPanel>
      </DialogContent>
      <DialogFooter alignment={ui.state.isSmallScreen ? 'centre' : 'right'}>
        {/* <div className={buttonWrapperClasses}> */}
        <Button
          label={t('*:str_ButtonCancel')}
          buttonStyle={'negative'}
          onClick={() => {
            userFlow.setNextStep();
          }}
        />
        <Button
          label={t('*:str_ButtonChangeProduct')}
          buttonStyle={'primary'}
          onClick={() => {
            onChangeProduct(selectedProduct?.ref);
          }}
        />
        {/* </div> */}
      </DialogFooter>
    </Dialog>
  );
};

export default ChangeProductDialog;
